export default "__VITE_ASSET__By9Ao1Yb__"